import {Linking, Platform, Alert} from 'react-native';

export const openExternalLink = async (url?: string): Promise<void> => {
  if (!url) {
    return;
  }
  const targetUrl = url.includes('//') ? url : `https://${url}`;
  if (await Linking.canOpenURL(targetUrl)) {
    if (Platform.OS === 'web') {
      window.open(targetUrl, '_blank');
    } else {
      await Linking.openURL(targetUrl);
    }
  } else Alert.alert('Не удалось открыть ссылку');
};

export const openExternalPhone = async (phoneNum?: string): Promise<void> => {
  if (!phoneNum) {
    return;
  }
  let phoneNumber = phoneNum;
  if (Platform.OS !== 'android') {
    phoneNumber = `telprompt:${phoneNum}`;
  } else {
    phoneNumber = `tel:${phoneNum}`;
  }
  if (await Linking.canOpenURL(phoneNumber)) {
    await Linking.openURL(phoneNumber);
  } else Alert.alert('Не удалось открыть номер');
};
